export default __webpack_public_path__ + "static/media/logo-white.d976b79c.png";